<template>
	<div>
		<h2 class="heading-4 mb-100">{{ heading }}</h2>
		<div v-if="updates.length === 1">
			<AssetDetailsUpdateCard v-if="appStore.isMobile" :update="updates[0]" />
			<AssetDetailsUpdateCardHorizontal v-else :update="updates[0]" />
		</div>
		<div
			v-else
			:class="[
				'display-flex gap-100 flex-direction-column-smo multiple-updates-container',
				{ 'contain-scroll': !appStore.isMobile }
			]"
		>
			<div v-for="(update, i) in updates" :key="i" class="flex-row">
				<AssetDetailsUpdateCard v-if="i === 0 || !appStore.isMobile" :update="update" />
				<AssetDetailsUpdateCardHorizontal v-else :update="update" :position-image-right="true" />
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { Asset, AssetUpdateSanity } from 'types/assets';
import AssetDetailsUpdateCard from '@components/marketing-site/asset-details/asset-details-update-card.vue';
import AssetDetailsUpdateCardHorizontal from '@components/marketing-site/asset-details/asset-details-update-card-horizontal.vue';
import { computed } from 'vue';
import { pluralize } from '@filters/shared-filters';
import { useAppStore } from '@stores/app';

interface Props {
	asset: Asset;
	useAssociatedUpdates?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
	useAssociatedUpdates: false
});

const appStore = useAppStore();

const updates = computed((): Array<AssetUpdateSanity> => {
	return props.asset.associatedUpdates ?? [];
});

const heading = computed((): string => pluralize(updates.value.length, 'Update'));
</script>
<style lang="scss" scoped>
@use '../../../styles/constants/colors.scss' as *;

.multiple-updates-container {
	overflow: auto;

	&.contain-scroll {
		overscroll-behavior-x: contain;

		&::-webkit-scrollbar {
			height: 14px;
		}

		&::-webkit-scrollbar-track {
			background: token('bg-secondary');
			border-radius: 4px;
		}

		&::-webkit-scrollbar-thumb {
			background-color: gray(20);
			border-radius: 4px;
		}
	}
}
</style>
